import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { TipoPagamento } from "../api/dto/tipo-pagamento";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TipoPagamentoService {

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'tipos-pagamento/';

    buscarPorId(tipoPagamentoId?: number): Observable<TipoPagamento> {
        return this.http.get<TipoPagamento>(this.url + tipoPagamentoId);
    }

    listarPorEmpresa(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + 'empresa/' + empresaId);
    }

    listarPorEmpresaEOperacaoDespesa(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + `empresa/${empresaId}/operacao/despesa`);
    }

    listarPorEmpresaEContaEOperacaoInterno(empresaId?: number, contaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + `empresa/${empresaId}/conta/${contaId}/operacao/interno`);
    }

    listarPorEmpresaEOperacaoInterno(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + `empresa/${empresaId}/operacao/interno`);
    }

    listarPorEmpresaEOperacaoReceita(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + `empresa/${empresaId}/operacao/receita`);
    }

    listarPorEmpresaEOperacaoCaixa(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + `empresa/${empresaId}/caixa`);
    }

    listarTiposPagamentoOrigemCaixaPorEmpresa(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + 'empresa/' + empresaId + '/origem-caixa');
    }

    listarTiposPagamentoDestinoCaixaPorEmpresa(empresaId?: number): Observable<TipoPagamento[]> {
        return this.http.get<TipoPagamento[]>(this.url + 'empresa/' + empresaId + '/destino-caixa');
    }

    salvar(tipoPagamento?: TipoPagamento): Observable<TipoPagamento> {
        return this.http.post<TipoPagamento>(this.url, tipoPagamento);
    }

    atualizar(tipoPagamento?: TipoPagamento, id?: number): Observable<TipoPagamento>{
        return this.http.put<TipoPagamento>(this.url + id, tipoPagamento);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}${id}`);
    }
}